import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { isValidElement, useContext, useRef } from 'react';
import clsx from 'clsx';
import { BORDER_BOTTOM } from '../utils/constant';
import Icon from '../icon';
import useHeight from '../hooks/use-height';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';

var NavBar = function NavBar(props) {
  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('nav-bar', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var navBarRef = useRef(null);
  var navBarHeight = useHeight(navBarRef);

  var onClickLeft = function onClickLeft(event) {
    if (props.onClickLeft) props.onClickLeft(event);
  };

  var onClickRight = function onClickRight(event) {
    if (props.onClickRight) props.onClickRight(event);
  };

  var renderLeft = function renderLeft() {
    if (typeof props.leftText !== 'string' && /*#__PURE__*/isValidElement(props.leftText)) {
      return props.leftText;
    }

    return [props.leftArrow && /*#__PURE__*/React.createElement(Icon, {
      key: "arrow",
      className: clsx(bem('arrow')),
      name: "arrow-left"
    }), props.leftText && /*#__PURE__*/React.createElement("span", {
      key: "text",
      className: clsx(bem('text'))
    }, props.leftText)];
  };

  var renderRight = function renderRight() {
    if (typeof props.rightText !== 'string' && /*#__PURE__*/isValidElement(props.rightText)) {
      return props.rightText;
    }

    return /*#__PURE__*/React.createElement("span", {
      className: clsx(bem('text'))
    }, props.rightText);
  };

  var renderNavBar = function renderNavBar() {
    var title = props.title,
        fixed = props.fixed,
        border = props.border,
        zIndex = props.zIndex;

    var style = _objectSpread({
      zIndex: zIndex !== undefined ? +zIndex : undefined
    }, props.style);

    var hasLeft = props.leftArrow || props.leftText;
    var hasRight = props.rightText;
    return /*#__PURE__*/React.createElement("div", {
      ref: navBarRef,
      style: style,
      className: clsx(bem({
        fixed: fixed,
        'safe-area-inset-top': props.safeAreaInsetTop
      }), _defineProperty({}, BORDER_BOTTOM, border), props.className)
    }, /*#__PURE__*/React.createElement("div", {
      className: clsx(bem('content'))
    }, hasLeft && /*#__PURE__*/React.createElement("div", {
      className: clsx(bem('left')),
      onClick: onClickLeft
    }, renderLeft()), /*#__PURE__*/React.createElement("div", {
      className: clsx(bem('title'), 'rv-ellipsis')
    }, title), hasRight && /*#__PURE__*/React.createElement("div", {
      className: clsx(bem('right')),
      onClick: onClickRight
    }, renderRight())));
  };

  var renderPlaceholder = function renderPlaceholder() {
    if (props.fixed && props.placeholder) {
      return /*#__PURE__*/React.createElement("div", {
        className: clsx(bem('placeholder')),
        style: {
          height: navBarHeight ? "".concat(navBarHeight, "px") : undefined
        }
      });
    }

    return null;
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, renderPlaceholder(), renderNavBar());
};

NavBar.defaultProps = {
  border: true
};
export default NavBar;